import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";

export default function CmsHomePreview() {
  const { user } = useAuth();
  const [draft, setDraft] = useState(undefined);
  useEffect(() => {
    if (user?.role === "admin") api.get("/admin/cms/home").then(({ data }) => setDraft(data.draft || data.published || {})).catch(() => setDraft(null));
  }, [user]);
  if (!user || user.role !== "admin") return <div className="p-10 text-center text-sm" data-testid="cms-preview-denied">Bu sayfa yalnızca yöneticiler içindir.</div>;
  if (draft === undefined) return <div className="p-10 text-center text-sm text-muted-foreground">Yükleniyor…</div>;
  return (
    <div data-testid="cms-preview-page">
      <div className="bg-amber-400 text-black text-center text-sm font-bold py-2" data-testid="cms-preview-banner">ÖNİZLEME — Bu görünüm henüz yayında değil</div>
      <Home previewContent={draft} />
    </div>
  );
}
